import Quote from '@/components/ui/quote'
import { type TypeSectionMasonarySkeleton } from '@/types/ctf/TypeSectionMasonary'
import type { Entry } from 'contentful'

type MasonrySectionEntry = Entry<TypeSectionMasonarySkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>

type SetOfMasonryCardsProps = MasonrySectionEntry['fields']

/**
 * A Masonary style layout of cards
 *
 * Currently used to layout quotes for the media page https://bitwarden.com/media-spotlight/ <br />
 * Could be expanded in future for to include card components as well as quote components
 */

// eslint-disable-next-line react/function-component-definition
export const SetOfMasonaryCards = ({ cards }: SetOfMasonryCardsProps) => {
  return (
    <section>
      <div className="max-w-8xl mx-auto px-5 lg:px-9 py-10 lg:py-20">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-8">
          {Array.isArray(cards) &&
            cards.map((card) => {
              if (!card) return null
              const { id } = card.sys
              return (
                <div key={id} className="mb-8 break-inside-avoid-column">
                  <Quote {...card.fields} />
                </div>
              )
            })}
        </div>
      </div>
    </section>
  )
}
